import { useQuery } from "@tanstack/react-query";
import { NOTIFICATIONS_COUNT_QUERY_KEY } from "Data/keys/QueryKeys";
import { NotificationApiV2 } from "Data/Notification.api.v2";

export const useQueryCountNewNotificationsObra = (
  constructionSiteId?: number | null
) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [NOTIFICATIONS_COUNT_QUERY_KEY, Number(constructionSiteId)],
    staleTime: 60 * 5 * 1000, // 5 minutes
    enabled: !!constructionSiteId,
    queryFn: async () => {
      const { data } = await NotificationApiV2.countNewNotifications({
        constructionSiteId
      });
      return data.data.count;
    },
  });

  return {
    data: data ?? 0,
    refetch,
    isLoading,
    isFetching,
    error,
  }
};
